<template>
  <div class="middle-box text-center loginscreen animated fadeInDown">
    <div>
      <div>
        <img class="logo" src="/static/logo-my-emateriel.svg">
      </div>
      <h3>{{ title }}</h3>
      <p>{{ message }}</p>
    </div>
  </div>
</template>

<script>
/**
 * PREPROD uniquement : connexion directe à partir d'une adresse e-mail ou d'un
 * id utilisateur, sans Azure.
 *
 * URL : /auth_preprod/<email ou id> (ex. /auth_preprod/prenom.nom@equans.com
 * ou /auth_preprod/2002). La garde est côté back : la route
 * /auth_preprod/{identifier} ne répond qu'en preprod (PREPROD_MOD='true') ou en
 * dev (cf. App\Controller\Api\PreprodAuthController), sinon 404.
 */
export default {
  name: "AuthPreprod",
  data() {
    return {
      title: "Connexion en cours…",
      message: "Authentification preprod pour " + this.$route.params.identifier
    };
  },
  mounted() {
    this.$store
      .dispatch("auth/loginPreprod", this.$route.params.identifier)
      .then(() => {
        // Rechargement complet plutôt qu'un $router.push : si une session était
        // déjà ouverte, le store garde en mémoire l'ancien profil (id, droits,
        // entrepôt) et le beforeEach du router ne le rafraîchirait pas.
        window.location.href = "/";
      })
      .catch(error => {
        this.title = "Connexion impossible";
        const status = error.response && error.response.data && error.response.data.status;

        if (error.response && error.response.status === 404 && !status) {
          this.message = "L'authentification preprod n'est pas activée sur cet environnement.";
        } else if (status === "preprod_user_not_found_in_database") {
          this.message = "Aucun utilisateur ne correspond à " + this.$route.params.identifier + ".";
        } else if (status === "preprod_user_inactive_in_database") {
          this.message = "Le compte " + this.$route.params.identifier + " est inactif.";
        } else {
          this.message = "Une erreur est survenue lors de la connexion.";
        }
      });
  }
};
</script>

<style lang="scss" scoped>
.logo {
  margin-bottom: 50px;
}
</style>



// WEBPACK FOOTER //
// src/components/Security/authPreprod.vue